import React from 'react'
import { Play } from '../Common/SI'
import { PlayCard } from './PlayCard'
import './PlayCards.css'

export interface PlayCardsProps {
	plays: Play[]
}

export function PlayCards(props: PlayCardsProps): JSX.Element {
	return (
		<div className='play-list'>
			{
				props.plays.map((play, i) => (
					<PlayCard key={i} play={play} />
				))
			}
		</div>
	)
}
